import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { IHTMLAttributes } from '../../../shared/image-load-container/image-load-container';

interface IProps {
  imageSource: string;
  attributes: IHTMLAttributes;
  className: string;
}

const PresenterMobileSlideView: FC<IProps> = ({ imageSource, attributes, className }) => {
  return (
    <div
      className={className}
      {...attributes}
      style={{ backgroundImage: `url(${imageSource})` }}
    />
  );
};

export default observer(PresenterMobileSlideView);